<template>
  <form>
    <v-container>
      <v-row>
        <v-col cols="12" md="6">
          <banking-countries
            ref="countryCode"
            v-model="countryCode"
            label="Country"
            @input="handleBankingType">
          </banking-countries>
        </v-col>
        <v-col cols="12" md="6">
          <banking-currency
            ref="currencyCode"
            :countryCode="countryCode"
            v-model="currencyCode"
            label="Currency"
            @input="handleBankingType">
          </banking-currency>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <v-text-field
            ref="accountHolderName"
            label="Account Holder Name"
            v-model="accountHolderName"
            placeholder="John Smith Limited"
            :rules="[() => !!accountHolderName || 'This field is required']"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <component
            ref="accountDetails"
            v-model="accountDetails"
            :is="accountDetailsForm">
          </component>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <v-alert
            type="info"
            class="d-inline-block"
          >
            {{ $t("bankingOnboarding.directDebitMandateNotice") }}
          </v-alert>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn class="mr-4" @click="submit" :loading="saveLoading">{{ $t("bankingOnboarding.create") }}</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BankingCurrency from './elements/BankingCurrencies.vue';
import BankingCountries from './elements/BankingCountries.vue';
import DefaultAccountDetailsForm from './banking/DefaultAccountDetailsForm.vue';
import TransitAccountDetailsForm from './banking/TransitAccountDetailsForm.vue';
import IbanAccountDetailsForm from './banking/IbanAccountDetailsForm.vue';
import { formValidation } from '../mixins/validation.mixins';

export default {
  mixins: [formValidation],
  props: {
    saveLoading: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    BankingCurrency,
    BankingCountries,
    DefaultAccountDetailsForm,
    TransitAccountDetailsForm,
    IbanAccountDetailsForm,
  },
  created() {
    this.$store.dispatch('utils/loadCountries');
  },
  data() {
    return {
      countryCode: null,
      currencyCode: null,
      accountDetailsForm: 'DefaultAccountDetailsForm',
      accountHolderName: '',
      accountDetails: {
        routingNumber: '',
        accountNumber: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      getBankInfoFormat: 'stripe/getBankInfoFormat',
    }),
  },
  methods: {
    ...mapActions({
      createToken: 'stripe/createToken',
    }),
    handleBankingType() {
      this.accountDetails = {
        routingNumber: '',
        accountNumber: '',
      };
      const bankInfoFormat = this.getBankInfoFormat(this.countryCode, this.currencyCode) || 'default';
      this.accountDetailsForm = `${bankInfoFormat.charAt(0).toUpperCase() + bankInfoFormat.slice(1)}AccountDetailsForm`;
    },
    async submit() {
      this.validate();
      if (!this.accountDetails.accountNumber
        || !this.countryCode
        || !this.currencyCode
        || !this.accountHolderName
      ) {
        return;
      }

      if (this.getBankInfoFormat(this.countryCode, this.currencyCode) !== 'iban' && !this.accountDetails.routingNumber) {
        return;
      }
      this.$emit('submit', {
        accountNumber: this.accountDetails.accountNumber,
        routingNumber: this.accountDetails.routingNumber,
        country: this.countryCode,
        currency: this.currencyCode,
        accountHolderName: this.accountHolderName,
      });
    },
  },
};
</script>

<style scope>

</style>
